import { useEffect, useState } from 'react';
import '../styles/CuadreCaja.css';

const CuadreCaja = () => {
  const [cuadreHoy, setCuadreHoy] = useState(null);
  const [resumenSemanal, setResumenSemanal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showCerrarModal, setShowCerrarModal] = useState(false);
  const [efectivoContado, setEfectivoContado] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      setLoading(true);

      // Simular llamadas a la API
      // const cuadreResponse = await cuadreCajaService.getCuadreHoy();
      // const resumenResponse = await cuadreCajaService.getResumenSemanal();

      // Datos simulados hasta implementar el servicio
      const cuadreSimulado = {
        fecha: new Date().toISOString().split('T')[0],
        dia_semana: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][new Date().getDay()],
        saldo_inicial_caja: 5400.00,
        movimientos: {
          ingresos: {
            caja_chica: [
              { concepto: 'Recarga de efectivo', monto: 2000.00, hora: '09:00' }
            ],
            pagos_efectivo: 15600.00,
            desembolsos_prestamos: 45000.00,
            total: 62600.00
          },
          egresos: {
            caja_chica: [
              { concepto: 'Pago de combustible', monto: 1200.00, hora: '10:30' },
              { concepto: 'Compra de materiales', monto: 800.00, hora: '14:15' }
            ],
            gastos_operativos: 3500.00,
            total: 5500.00
          }
        },
        total_ingresos: 62600.00,
        total_egresos: 5500.00,
        saldo_final_caja: 62500.00,
        balance_neto: 57100.00,
        estado_calculado: 'positivo'
      };

      setCuadreHoy(cuadreSimulado);

      const resumenSimulado = {
        periodo: {
          inicio: '2025-10-07',
          fin: '2025-10-13'
        },
        totales: {
          ingresos: 425000.00,
          egresos: 85000.00,
          balance_neto: 340000.00
        },
        cuadres_diarios: [
          { fecha: '2025-10-07', total_ingresos: 58000, total_egresos: 12000, balance_neto: 46000 },
          { fecha: '2025-10-08', total_ingresos: 62000, total_egresos: 15000, balance_neto: 47000 },
          { fecha: '2025-10-09', total_ingresos: 55000, total_egresos: 11000, balance_neto: 44000 },
          { fecha: '2025-10-10', total_ingresos: 68000, total_egresos: 18000, balance_neto: 50000 },
          { fecha: '2025-10-11', total_ingresos: 59000, total_egresos: 14000, balance_neto: 45000 },
          { fecha: '2025-10-12', total_ingresos: 61000, total_egresos: 10000, balance_neto: 51000 },
          { fecha: '2025-10-13', total_ingresos: 62000, total_egresos: 5000, balance_neto: 57000 }
        ]
      };

      setResumenSemanal(resumenSimulado);

    } catch (error) {
      console.error('Error cargando datos:', error);
      setError('Error cargando los datos del cuadre');
    } finally {
      setLoading(false);
    }
  };

  const abrirModalCerrar = () => {
    if (cuadreHoy) {
      setEfectivoContado(cuadreHoy.saldo_final_caja.toString());
    }
    setShowCerrarModal(true);
    setError('');
    setSuccess('');
  };

  const cerrarModal = () => {
    setShowCerrarModal(false);
    setEfectivoContado('');
    setObservaciones('');
    setError('');
    setSuccess('');
  };

  const handleCerrarCaja = async (e) => {
    e.preventDefault();

    if (!efectivoContado || parseFloat(efectivoContado) < 0) {
      setError('El efectivo contado debe ser un número válido');
      return;
    }

    try {
      setLoading(true);

      // Simular llamada a la API
      // await cuadreCajaService.cerrarCaja({
      //   efectivo_contado: parseFloat(efectivoContado),
      //   observaciones
      // });

      const diferencia = parseFloat(efectivoContado) - cuadreHoy.saldo_final_caja;

      setSuccess(`Caja cerrada exitosamente. Diferencia: RD$${Math.abs(diferencia).toFixed(2)} ${diferencia >= 0 ? '(sobrante)' : '(faltante)'}`);

      setTimeout(() => {
        cerrarModal();
        cargarDatos();
      }, 2000);

    } catch (error) {
      console.error('Error cerrando caja:', error);
      setError('Error al cerrar la caja');
    } finally {
      setLoading(false);
    }
  };

  const formatearMonto = (monto) => {
    return new Intl.NumberFormat('es-DO', {
      style: 'currency',
      currency: 'DOP'
    }).format(monto);
  };

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-DO');
  };

  if (loading && !cuadreHoy) {
    return (
      <div className="loading-container">
        <div className="loading">Cargando datos del cuadre de caja...</div>
      </div>
    );
  }

  return (
    <div className="cuadre-caja-container">
      {/* Header */}
      <div className="cuadre-header">
        <h1>📊 Cuadre de Caja</h1>
        <p>Control y cierre diario de operaciones</p>
      </div>

      {/* Cuadre del día actual */}
      {cuadreHoy && (
        <div className="cuadre-actual-section">
          <div className="cuadre-header-info">
            <h2>🗓️ Cuadre de Hoy - {cuadreHoy.dia_semana}, {formatearFecha(cuadreHoy.fecha)}</h2>
            <button className="btn-cerrar-caja" onClick={abrirModalCerrar}>
              🔒 Cerrar Caja
            </button>
          </div>

          {/* Cards de resumen */}
          <div className="resumen-cards">
            <div className="resumen-card saldo-inicial">
              <div className="card-icon">🏦</div>
              <div className="card-content">
                <h3>Saldo Inicial</h3>
                <div className="card-value">{formatearMonto(cuadreHoy.saldo_inicial_caja)}</div>
              </div>
            </div>
            <div className="resumen-card total-ingresos">
              <div className="card-icon">⬆️</div>
              <div className="card-content">
                <h3>Total Ingresos</h3>
                <div className="card-value">{formatearMonto(cuadreHoy.total_ingresos)}</div>
              </div>
            </div>
            <div className="resumen-card total-egresos">
              <div className="card-icon">⬇️</div>
              <div className="card-content">
                <h3>Total Egresos</h3>
                <div className="card-value">{formatearMonto(cuadreHoy.total_egresos)}</div>
              </div>
            </div>
            <div className="resumen-card saldo-final">
              <div className="card-icon">💰</div>
              <div className="card-content">
                <h3>Saldo Final Calculado</h3>
                <div className="card-value">{formatearMonto(cuadreHoy.saldo_final_caja)}</div>
              </div>
            </div>
          </div>

          {/* Detalles de movimientos */}
          <div className="movimientos-detalle">
            <div className="movimientos-grid">
              {/* Ingresos */}
              <div className="movimientos-columna ingresos">
                <h3>📈 Ingresos del Día</h3>

                <div className="movimiento-grupo">
                  <h4>💵 Caja Chica</h4>
                  {cuadreHoy.movimientos.ingresos.caja_chica.map((mov, index) => (
                    <div key={index} className="movimiento-item">
                      <span className="movimiento-concepto">{mov.concepto}</span>
                      <span className="movimiento-hora">{mov.hora}</span>
                      <span className="movimiento-monto">+{formatearMonto(mov.monto)}</span>
                    </div>
                  ))}
                </div>

                <div className="movimiento-grupo">
                  <h4>💳 Pagos de Préstamos</h4>
                  <div className="movimiento-total">
                    <span>Total en efectivo</span>
                    <span>+{formatearMonto(cuadreHoy.movimientos.ingresos.pagos_efectivo)}</span>
                  </div>
                </div>

                <div className="movimiento-grupo">
                  <h4>💸 Desembolsos de Préstamos</h4>
                  <div className="movimiento-total">
                    <span>Total desembolsado</span>
                    <span>+{formatearMonto(cuadreHoy.movimientos.ingresos.desembolsos_prestamos)}</span>
                  </div>
                </div>

                <div className="total-seccion">
                  <strong>Total Ingresos: {formatearMonto(cuadreHoy.movimientos.ingresos.total)}</strong>
                </div>
              </div>

              {/* Egresos */}
              <div className="movimientos-columna egresos">
                <h3>📉 Egresos del Día</h3>

                <div className="movimiento-grupo">
                  <h4>💵 Caja Chica</h4>
                  {cuadreHoy.movimientos.egresos.caja_chica.map((mov, index) => (
                    <div key={index} className="movimiento-item">
                      <span className="movimiento-concepto">{mov.concepto}</span>
                      <span className="movimiento-hora">{mov.hora}</span>
                      <span className="movimiento-monto">-{formatearMonto(mov.monto)}</span>
                    </div>
                  ))}
                </div>

                <div className="movimiento-grupo">
                  <h4>🏢 Gastos Operativos</h4>
                  <div className="movimiento-total">
                    <span>Total gastos aprobados</span>
                    <span>-{formatearMonto(cuadreHoy.movimientos.egresos.gastos_operativos)}</span>
                  </div>
                </div>

                <div className="total-seccion">
                  <strong>Total Egresos: {formatearMonto(cuadreHoy.movimientos.egresos.total)}</strong>
                </div>
              </div>
            </div>

            {/* Balance neto */}
            <div className={`balance-neto ${cuadreHoy.estado_calculado}`}>
              <h3>💹 Balance Neto del Día</h3>
              <div className="balance-valor">
                {formatearMonto(cuadreHoy.balance_neto)}
              </div>
              <span className={`estado-badge ${cuadreHoy.estado_calculado}`}>
                {cuadreHoy.estado_calculado === 'positivo' ? '✅ Positivo' : '❌ Negativo'}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Resumen semanal */}
      {resumenSemanal && (
        <div className="resumen-semanal-section">
          <h2>📅 Resumen de la Semana</h2>
          <p>{formatearFecha(resumenSemanal.periodo.inicio)} - {formatearFecha(resumenSemanal.periodo.fin)}</p>

          <div className="resumen-semanal-cards">
            <div className="semanal-card ingresos-semanales">
              <h3>Total Ingresos</h3>
              <div className="semanal-valor">{formatearMonto(resumenSemanal.totales.ingresos)}</div>
            </div>
            <div className="semanal-card egresos-semanales">
              <h3>Total Egresos</h3>
              <div className="semanal-valor">{formatearMonto(resumenSemanal.totales.egresos)}</div>
            </div>
            <div className="semanal-card balance-semanal">
              <h3>Balance Neto</h3>
              <div className="semanal-valor">{formatearMonto(resumenSemanal.totales.balance_neto)}</div>
            </div>
          </div>

          {/* Gráfico de la semana */}
          <div className="grafico-semanal">
            <h3>📊 Balance Diario de la Semana</h3>
            <div className="grafico-barras">
              {resumenSemanal.cuadres_diarios.map((dia, index) => {
                const maxValue = Math.max(...resumenSemanal.cuadres_diarios.map(d => d.balance_neto));
                const alturaProporcion = (dia.balance_neto / maxValue) * 100;

                return (
                  <div key={index} className="barra-dia">
                    <div
                      className="barra"
                      style={{ height: `${alturaProporcion}%` }}
                      title={`${formatearFecha(dia.fecha)}: ${formatearMonto(dia.balance_neto)}`}
                    ></div>
                    <span className="dia-label">
                      {new Date(dia.fecha).toLocaleDateString('es-DO', { weekday: 'short' })}
                    </span>
                    <span className="dia-valor">
                      {formatearMonto(dia.balance_neto)}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Modal de cierre de caja */}
      {showCerrarModal && (
        <div className="modal-overlay" onClick={cerrarModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>🔒 Cerrar Caja del Día</h2>
              <button className="btn-cerrar" onClick={cerrarModal}>×</button>
            </div>

            <form onSubmit={handleCerrarCaja} className="modal-form">
              {error && <div className="error-message">❌ {error}</div>}
              {success && <div className="success-message">✅ {success}</div>}

              <div className="cierre-info">
                <div className="info-item">
                  <label>Saldo Calculado:</label>
                  <span className="saldo-calculado">{cuadreHoy ? formatearMonto(cuadreHoy.saldo_final_caja) : 'RD$0'}</span>
                </div>
              </div>

              <div className="form-group">
                <label>Efectivo Contado *</label>
                <input
                  type="number"
                  value={efectivoContado}
                  onChange={(e) => setEfectivoContado(e.target.value)}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  required
                />
              </div>

              {efectivoContado && cuadreHoy && (
                <div className="diferencia-info">
                  <label>Diferencia:</label>
                  <span className={`diferencia ${parseFloat(efectivoContado) - cuadreHoy.saldo_final_caja >= 0 ? 'positiva' : 'negativa'}`}>
                    {formatearMonto(Math.abs(parseFloat(efectivoContado) - cuadreHoy.saldo_final_caja))}
                    {parseFloat(efectivoContado) - cuadreHoy.saldo_final_caja >= 0 ? ' (Sobrante)' : ' (Faltante)'}
                  </span>
                </div>
              )}

              <div className="form-group">
                <label>Observaciones</label>
                <textarea
                  value={observaciones}
                  onChange={(e) => setObservaciones(e.target.value)}
                  placeholder="Observaciones adicionales sobre el cierre de caja..."
                  rows="3"
                />
              </div>

              <div className="modal-actions">
                <button type="button" className="btn-cancelar" onClick={cerrarModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn-confirmar" disabled={loading}>
                  {loading ? 'Cerrando...' : '🔒 Confirmar Cierre'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CuadreCaja;